// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './Vuex/store'
import Antd from 'ant-design-vue'
import BackTop from '@mlqt/vue-back-top'
import CripNotice from 'crip-vue-notice'
import './assets/js/mixin'
import 'ant-design-vue/dist/antd.css'
import './assets/css/index.css'

Vue.use(BackTop)
Vue.use(Antd)
Vue.config.productionTip = false
Vue.use(CripNotice, {
  duration: 1.5,
  styles: { top: '15px', right: '15px' },
  className: 'notices',
  icons: {
    info: 'fas fa-info-circle',
    success: 'fas fa-check-circle',
    warning: 'fas fa-exclamation-circle',
    error: 'fas fa-times-circle',
    close: 'fas fa-times'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js